import React, { createContext, useContext, useState } from "react";

interface MenuOpenContextProps {
  isMenuOpen: boolean;
  isWorkManagementMenuOpen: boolean;
  isServiceManagementMenuOpen: boolean;
  isInnerboxMenuOpen: boolean;
  toggleMenu: () => void;
  handleProductsMenuToggle: (number: number) => void;
}

export const MenuOpenContext = createContext<MenuOpenContextProps | undefined>(undefined);

export const MenuOpenProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isWorkManagementMenuOpen, setIsWorkManagementMenuOpen] = useState(false);
  const [isServiceManagementMenuOpen, setIsServiceManagementMenuOpen] = useState(false);
  const [isInnerboxMenuOpen, setIsInnerboxMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(prev => !prev);
  }

  const handleProductsMenuToggle = (number: number) => {
    setIsWorkManagementMenuOpen(number === 1);
    setIsServiceManagementMenuOpen(number === 2);
    setIsInnerboxMenuOpen(number === 3);
  }

  return (
    <MenuOpenContext.Provider value={{ isMenuOpen, toggleMenu, isWorkManagementMenuOpen, isServiceManagementMenuOpen, isInnerboxMenuOpen, handleProductsMenuToggle }}>
      {children}
    </MenuOpenContext.Provider>
  );
};

export const useMenuOpen = () => {
  const context = useContext(MenuOpenContext);
  if (!context) {
    throw new Error('useMenuOpen must be used within a MenuOpenProvider');
  }
  return context;
}